import React from "react";
import { Modal } from "antd";
import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress } from "@mui/material";

import v2Styles from "../v2Styles.module.css";

export default function ExportLimitModal({
  visible,
  onClose,
  onConfirm,
  loading = false,
  title = "Export via email?",
  message = "",
  cancelText = "Cancel",
  okText = "Yes, continue",
}) {
  return (
    <Modal
      className="cs-modal-v2"
      centered
      footer={null}
      visible={visible}
      maskClosable={false}
      onCancel={onClose}
      destroyOnClose={true}
      width={600}
      closeIcon={<div className={v2Styles.ModalCloseIcon}><CloseIcon /></div>}
    >
      <div className="v2-modal-container">
        <div>
          <div className="container-fluid px-0">
            <div className="row">
              <div className="col-12">
                <div className={v2Styles.ModalHeading}>{title}</div>
                <div>
                  <hr className="v3-modal-hr" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 mb-3">
                {message}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="d-flex justify-content-end align-items-center" style={{ gap: "5px" }}>
                  {loading ? <CircularProgress size={20} /> : ""}
                  <button
                    type="button"
                    className={`${v2Styles.OutlinedButton} ${v2Styles.DangerColor}`}
                    onClick={onClose}
                    disabled={loading}
                  >
                    {cancelText}
                  </button>
                  <button
                    type="button"
                    className={v2Styles.PrimaryButton}
                    onClick={onConfirm}
                    disabled={loading}
                  >
                    {okText}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
